import { AxiosError } from 'axios';
import { GET_ADMISSION_LEVEL_VACANCIES_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { GET_ADMISSION_LEVEL_VACANCIES_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface AdmissionLevelVacanciesModel {
  admissionLevel: string;
  dateOfBirthFrom: string;
  dateOfBirthTo: string;
  totalExamVacancy: number;
  uuid: string;
  vacanciesLeft: number;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  year: number;
  uuid: string;
  onSuccess?: (data: any) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetAdmissionLevelVacancies = ({
  year,
  uuid,
  onSuccess,
  onError,
  enabled = true,
}: Input) => {
  const getAdmissionLevelVacancies = async () => {
    const res = await axiosClient.get<AdmissionLevelVacanciesModel[]>(
      GET_ADMISSION_LEVEL_VACANCIES_URL(year, uuid)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_ADMISSION_LEVEL_VACANCIES_QUERY_KEY, uuid, year],
    getAdmissionLevelVacancies,
    {
      onSuccess,
      onError,
      enabled,
    },
    true,
    false
  );
};
